import SectionHead from './SectionHead'

const STEPS = [
  {
    title: 'Start on your own',
    meta: '2 min',
    desc: 'Sign in with Google or a verified email, type your name, and you are in. Running it with your team instead? Create a private room with a name and a password.',
  },
  {
    title: 'Share the room code',
    meta: '6 characters',
    desc: 'For a team session, send the code so everyone can join from any device. Going solo skips this step.',
  },
  {
    title: 'Work through the five stages',
    meta: '25 to 90 min',
    desc: 'Scout, Archivist and Builder take the conversation in turn. About 25 minutes on your own, about 90 with a team.',
  },
]

export default function HowItWorksSection() {
  return (
    <section id="how-it-works" className="bg-stone py-14 md:py-16">
      <div className="mktg-container">
        <SectionHead mark="SECT. 02" title="How it runs" />

        <ol className="ledger max-w-3xl">
          {STEPS.map((step, i) => (
            <li key={step.title} className="flex gap-4 md:gap-6 p-5 md:p-6">
              <span className="mono-label text-teal pt-1 shrink-0 tabular-nums">
                {String(i + 1).padStart(2, '0')}
              </span>
              <div className="min-w-0">
                <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1 mb-1">
                  <h3 className="font-display text-lg md:text-xl text-navy">{step.title}</h3>
                  <span className="mono-label text-navy/70">{step.meta}</span>
                </div>
                <p className="text-navy/70 text-sm md:text-base leading-relaxed">{step.desc}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  )
}
